import { gate } from 'hub-http/gates';
export const SUBSCRIPTION_GROUP_SETTINGS = 'subscriptions:groupSettings';
export const COPY_PASTE_ACTION_CONFIG = 'Workflows:CopyPasteActionConfig';
export const ACTION_SETS_V2 = 'Workflows:ActionSetsV2';
export const AI_GENERATED_WORKFLOWS = 'Automation:AIGeneratedWorkflows';
export const ALTER_LIST_MEMBERSHIP_MIGRATION = 'AutomationActions:AlterListMembershipMigration';
export const SLACK_NOTIFICATION_MIGRATION = 'AutomationActions:SlackActionMigration';
export const DEBUGGER = 'Workflows:DebuggerV1';
export const SINGLE_ACTION_TEST = gate('Automation:ChatGPTAction');
export const CREATE_FROM_CANVAS = 'Workflows:CreateFromCanvas';
export const ILS_GOALS_MIGRATION = 'workflows:fe:ilsGoalsMigration';
export const ENFORCE_FIELD_LEVEL_PERMISSIONS = 'Automation:EnforceFieldLevelPermissions';
export const SUPPORT_SELECTING_SENSITIVE_PROPERTIES = gate('Automation:SupportSelectingSensitiveProperties');
export const TEST_V2 = gate('Workflows:TestV2');
export const GO_TO_ACTION_FLOW_VIEW_TEST = gate('Workflows:GoToActionFlowViewTest');
export const DATASET_FUNCTIONALITY = gate('DataStudio:BetaAccess');
export const NEXT_ACTION_RECOMMENDER = gate('Automation:NextActionRecommender');
export const METRICS_LIMITS = gate('Automation:Observability:MetricsLimits');
export const OBJECTLESS_WORKFLOWS = gate('Automation:ObjectlessWorkflows');
export const COLLABORATION_GENERATE_ACTION = gate('Automation:Collab:GenerateAction');
export const COLLABORATION_GENERATE_ACTION_ELIGIBLE_CUSTOMERS = gate('Automation:Collab:GenerateAction:EligibleCustomers');
export const AI_NAME_SUGGESTION = gate('Workflows:AINameGeneration');
export const BRANCH_DESCRIPTION = gate('Workflows:BranchDescriptionCards');